import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { compareFormatter } from "../../../Utils/StaticData/Constant";
import history from "../../../Utils/History";
import { Link } from "react-router-dom";
import {
  setStateParams,
  setPageName,
  setFormData,
  planSelectionContinue,
  getAgentIDListInPreEnrollForm,
  setDeepLink,
  setLoginStateParams,
  yearSelection,
  guestLogin,
  setTokenTORedux,
  getZipCodes,
  getPlansEmail,
  getPlanDetails,
  setCategoryName,
  getPlans,
  // setTokenTORedux,
  // getcmpNames,
  comparePlan,
} from "../../../Redux/Actions/webAppActions";
import SaveProgress from "./SaveProgress";
import { Text } from "react-internationalization";
import { LANG } from "../../translations/dynamic";

const useComponentWillMount = (callback) => {
  const [mounted, setMounted] = useState(false);
  if (!mounted) callback();

  useEffect(() => {
    setMounted(true);
  }, []);
};

const PlanCompareGrid = () => {
  const { cmpnames, planDetailTable, selectedPlansForCompare, planCardData } =
    useSelector((states) => states.webApp);
  const { deeplink, customerId } = useSelector((state1) => state1.login);
  const language = useSelector((state1) => state1.webApp.language);
  const [state, setState] = useState({ data: [], len: 0, planNames: [] });
  const dispatch = useDispatch();
  let arr = selectedPlansForCompare;

  const willmount = async () => {
    let queryString = window.location.search;
    let dpcustomerId = "";
    let zipCd = "";
    let countyCd = "";
    let stateCd = "";
    let countyName = "";
    let productID = "";
    let username = "";
    let productCategory = "";
    let selectedPlanName = "";
    let lang = "";
    let year = "";
    // let planCardData = "";
    // SONAR let index = 0;
    if (queryString.includes("deepLink=true")) {
      let queryStringArray = queryString.split("&");

      if (queryStringArray[1].includes("customerId")) {
        dpcustomerId = window.atob(queryStringArray[1].split("=")[1]);
      }
      if (queryStringArray[2].includes("zipCd")) {
        zipCd = window.atob(queryStringArray[2].split("=")[1]);
      }
      if (queryStringArray[3].includes("countyCd")) {
        countyCd = window.atob(queryStringArray[3].split("=")[1]);
        //index=queryStringArray[2].split("=")[1].indexOf("%")
        //countyCd=queryStringArray[2].split("=")[1].slice(0,index)
      }

      if (queryStringArray[4].includes("stateCd")) {
        stateCd = window.atob(queryStringArray[4].split("=")[1]);
      }
      // let decodedUrl=decodeURIComponent(window.location.href)
      //   countyName = window.atob(decodedUrl.split("&")[5].split("=")[1]);
      if (queryStringArray[5].includes("countyName")) {
        countyName = window.atob(queryStringArray[5].split("=")[1]);
      }

      if (queryStringArray[6].includes("productId")) {
        productID = window.atob(queryStringArray[6].split("=")[1]);
      }
      if (queryStringArray[7].includes("email")) {
        username = window.atob(queryStringArray[7].split("=")[1]);
      }
      if (queryStringArray[10].includes("productCategory")) {
        productCategory = window.atob(queryStringArray[10].split("=")[1]);
      }
      if (queryStringArray[11].includes("selectedPlanName")) {
        selectedPlanName = window.atob(queryStringArray[11].split("=")[1]);
      }
      if (queryStringArray[13].includes("year")) {
        year = window.atob(queryStringArray[13].split("=")[1]);
      }
      if (queryStringArray[14].includes("lang")) {
        lang = window.atob(queryStringArray[14].split("=")[1]);
      }
      //this.props.yearSelection("2023");
      dispatch(setStateParams("language", lang));
      dispatch(yearSelection(year));
      await dispatch(
        setDeepLink({
          deeplink: true,
          countyName: countyName,
          zipcode: zipCd,
          productId: productID,
          stateCd: stateCd,
          email: username,
        })
      );
      dispatch(setLoginStateParams("productId", productID))
      // await this.props.setDeepLink({
      //   deeplink: true,
      //   countyName: countyName,
      //   zipcode: zipCd,
      //   productId: productID,
      //   stateCd: stateCd,
      //   email: username,
      // });
      // this.props.setLoginStateParams("deeplinkflag", true);
      dispatch(setLoginStateParams("deeplinkflag", true));
      let guestpayload = {
        customerId: dpcustomerId,
        username: username,
      };
      //const guestLoginDetails = await this.props.guestLogin(guestpayload);
      const guestLoginDetails = await dispatch(guestLogin(guestpayload));
      //this.props.agentLogin(false);
      //await this.props.setTokenTORedux(guestLoginDetails.data.token);
      await dispatch(setTokenTORedux(guestLoginDetails.data.token));
      const responce = await dispatch(
        getPlans(zipCd, countyCd, dpcustomerId, stateCd, year)
      );
      let planCardDatas = responce.data.summaryList;
      await dispatch(getZipCodes(zipCd));
      await dispatch(setStateParams("county", countyName));
      await dispatch(
        getPlansEmail(
          zipCd,
          countyCd,
          dpcustomerId,
          stateCd,
          year,
          "Bearer " + guestLoginDetails.data.token
        )
      );

      let productidArray = productID ? productID.split(",") : [];
      arr = productidArray;
      dispatch(setStateParams("selectedPlansForCompare", productidArray));

      let cmppayload = [];
      for (let i = 0; i < productidArray.length; i++) {
        cmppayload[i] = planCardDatas.filter(
          (data1) => data1.productId.trim() === productidArray[i]
        )[0];
      }
      // this.props.setStateParams("cmpnames", cmppayload);
      dispatch(setStateParams("cmpnames", cmppayload));

      if (cmppayload.length > 0) {
        const list = cmppayload?.map((plan) => ({
          customerId: dpcustomerId,
          planId: plan.planId,
          productId: plan.productId,
          planName: plan.planName,
          planYear: year,
        }));
        // await this.props.comparePlan(list);
        const listData = await dispatch(comparePlan(list));
        let newData = [];
        if (Array.isArray(listData.data)) {
          listData.data.map((data2) => newData.push(data2.plansData));
        } else {
          newData = listData.data;
        }
        didMount(newData, cmppayload);
      }

      if (cmppayload.length === 1) {
        //await this.props.setLoginStateParams("selectedPlan", productID);
        await dispatch(setLoginStateParams("selectedPlan", productID));
        // await this.props.getPlanDetails(this.props?.customerId, productID);
        await dispatch(getPlanDetails(customerId, productID,year));
        //await this.props.setCategoryName(productCategory, selectedPlanName);
        await dispatch(setCategoryName(productCategory, selectedPlanName));
      }

      history.push("/e-Enroll/compare-plan");
    }
    // if (this.props.token === "" || this.props.token === undefined) {
    //   let plans = [];
    //   plans = JSON.parse(window.sessionStorage.getItem("cmpnames"));

    //   if (
    //     this.props.emailAddress === "" ||
    //     this.props.firstName === "" ||
    //     this.props.email === "" ||
    //     this.props.agentEmailId === undefined
    //   ) {
    //     if (window.sessionStorage.getItem("agentLogin") === "true") {
    //       this.props.setLoginStateParams(
    //         "agentEmailId",
    //         window.sessionStorage.getItem("email")
    //       );
    //       this.props.setLoginStateParams(
    //         "firstName",
    //         window.sessionStorage.getItem("firstName")
    //       );
    //       this.props.setLoginStateParams("agentLoggedIn", true);
    //       this.props.setLoginStateParams(
    //         "agentId",
    //         window.sessionStorage.getItem("agentId")
    //       );
    //       this.props.setLoginStateParams(
    //         "agencyIDSelected",
    //         window.sessionStorage.getItem("agencyId")
    //       );
    //       this.props.setStateParams("guestLoggedIn", false);
    //       this.props.setLoginStateParams("guestLogin", false);
    //     }
    //     if (
    //       window.sessionStorage.getItem("guestLogin") === "false" &&
    //       window.sessionStorage.getItem("agentLogin") === "false"
    //     ) {
    //       this.props.setLoginStateParams(
    //         "emailAddress",
    //         window.sessionStorage.getItem("email")
    //       );
    //       this.props.setLoginStateParams(
    //         "firstName",
    //         window.sessionStorage.getItem("firstName")
    //       );
    //       this.props.setStateParams("guestLoggedIn", false);
    //       this.props.setLoginStateParams("guestLogin", false);
    //       this.props.setLoginStateParams(
    //         "authenticatedData",
    //         JSON.parse(window.sessionStorage.getItem("authenticatedData"))
    //       );
    //     }
    //   }
    //   this.props.setStateParams("year", new Date().getFullYear());
    //   if (this.props.token === "" || this.props.token === undefined) {
    //     await this.props.setTokenTORedux(
    //       window.sessionStorage.getItem("token")
    //     );
    //   }
    //   if (plans?.length === 1) {
    //     let formPayload = {
    //       planId: plans[0].planId,
    //       productId: plans[0].productId,
    //       premiumAmount: plans[0].monthlyPremium,
    //       planName: plans[0].planName,
    //     };
    //     this.props.setFormData(formPayload);
    //   }
    //   this.props.getcmpNames(plans);
    //   const list = plans?.map((plan) => ({
    //     customerId: this.props?.customerId,
    //     planId: plan.planId,
    //     productId: plan.productId,
    //     planName: plan.planName,
    //   }));
    //   await this.props.comparePlan(list);
    // }
  };

  useComponentWillMount(() => willmount());

  //useed for data format to show in grid view
  useEffect(() => {
    // if (token === "" || token === undefined) {
    //   let plans = [];
    //   plans = JSON.parse(window.sessionStorage.getItem("cmpnames"));
    //       dispatch(setLoginStateParams("agentLoggedIn", false))
    //       dispatch(setLoginStateParams("userId",window.sessionStorage.getItem("userId")??""))
    //       dispatch(setStateParams("guestLoggedIn", true))
    //       dispatch(setLoginStateParams("guestLogin", true))
    //       dispatch(setStateParams("year", new Date().getFullYear()))
    //     dispatch(setTokenTORedux(
    //       window.sessionStorage.getItem("token")
    //     ))

    //   if (plans?.length === 1) {
    //     let formPayload = {
    //       planId: plans[0].planId,
    //       productId: plans[0].productId,
    //       premiumAmount: plans[0].monthlyPremium,
    //       planName: plans[0].planName,
    //     };
    //     dispatch(setFormData(formPayload))
    //   }

    //   const getCmp=async()=>{
    //     let p;
    //     await dispatch(getcmpNames(plans))
    //     const list = plans?.map((plan) => ({
    //       customerId: customerId,
    //       planId: plan.planId,
    //       productId: plan.productId,
    //       planName: plan.planName,
    //     }));
    //     p= await dispatch(comparePlan(list))
    //     console.log("p-",p.data)
    //     let y=[]
    //     p.data.forEach((x)=>{
    //       console.log("testt-",x)
    //       y.push(x.plansData)})
    //       await dispatch(setStateParams("planDetailTable",y))
    //   }
    //   getCmp();

    // }
    // if (token === "") {
    //   history.push("e-Enroll/login");
    //   return;
    // }
    didMount(planDetailTable, cmpnames);
  }, []);

  const didMount = async (planDetailTable1, cmpnames1) => {
    let resp1 = [];

    let data1 = [];
    let len1 = 0;

    let table = planDetailTable1?.length > 0 ? planDetailTable1 : resp1;
    if (table?.length > 0) {
      data1 = table;
      len1 = table.length;
    }
    let planNames1 = [];
    arr.forEach((r) => {
      if (planCardData.length > 0) {
        planCardData.forEach((q) => {
          if (q.productId === r) {
            planNames1.push(
              language === "es"
                ? q.planNameES?.toUpperCase()
                : q.planName?.toUpperCase()
            );
          }
        });
      } else {
        let plans = [];
        if (cmpnames1.length > 0) {
          plans = cmpnames1;
        } else {
          plans = JSON.parse(window.sessionStorage.getItem("cmpnames"));
        }
        if (planNames1.length < 1) {
          plans.forEach((r1) =>
            planNames1.push(
              language === "es"
                ? r1.planNameES?.toUpperCase()
                : r1.planName?.toUpperCase()
            )
          );
        }
      }
    });
    let formattedData = compareFormatter(data1);

    dispatch(setPageName("compare-plan"));
    setState({ data: formattedData, len: len1, planNames: planNames1 });
  };

  const enrollHandler = async (e, proId) => {
    // window.confirm(`product id is ${e.target.id}`);
    let cardInfo = planCardData.filter((d) => d.productId === e.target.id)[0];
    console.log("enroll=", cardInfo);
    e.preventDefault();
    let formPayload = {
      planId: cardInfo.planId,
      planName: language === "es" ? cardInfo.planNameES : cardInfo.planName,
      plan: cardInfo.planId,
      productCategory: cardInfo.productCategory ? cardInfo.productCategory : "",
    };
    if (planDetailTable.length > 1) {
      dispatch(
        setFormData({
          ...formPayload,
          productName: cardInfo.productName,
          productId: e.target.id,
        })
      );
    }
    let payload = {
      productId: deeplink === false ? e.target.id : proId,
      customerId: customerId,
    };
    let plnType = planCardData.filter((x) =>
      (x.productId === deeplink) === false ? e.target.id : proId
    )[0].planType;
    await dispatch(setStateParams("planType", plnType));
    const response = await dispatch(planSelectionContinue(payload, customerId));
    if (response.status === "OK") {
      // await dispatch(getAgentIDListInPreEnrollForm(customerId));
      dispatch(setStateParams("isUpdated", false));
      history.push("/e-Enroll/enrollOnline");
    }
  };

  const findSpanish = (key) => {
    let data3;
    console.log("working......",key);

    if (LANG.PLAN_DETAILS.DETAILS_KEYS[key]) {
      data3 = LANG.PLAN_DETAILS.DETAILS_KEYS[key];
    }else{
      data3 = key
    }
    console.log("working......2",data3);
    return data3;
  };

  const { data, planNames } = state;
  return (
    <main className="main-content-area bg-white" id="main-content">
      <div className="container-fluid container-xxl" id="page-wrap">
        <div className="panel-box">
          <div className="row">
            <div className="col-5">
              <h5 className="panel-heading bold">
                {planDetailTable.length > 1 ? (
                  <Text id="sharp.comparePlans" />
                ) : (
                  <Text id="sharp.planDetails" />
                )}
              </h5>
            </div>
            <div className="col-7 text-end">
              <SaveProgress />
            </div>
          </div>
          <div className="plan-details-container">
            <table className="plan-details-table width50">
              <thead
                className={
                  planDetailTable.length > 1 ? "thead-style2" : "thead-style1"
                }
              >
                <tr>
                  <td>
                    <Link
                      to="/e-Enroll/select-plan"
                      onClick={() => {
                        dispatch(setStateParams("selectedPlansForCompare", []));
                      }}
                    >
                      <i className="icon icon-left-open" />
                      <Text id="sharp.backToPlans" />
                    </Link>
                  </td>
                  {planNames.map((x, index) => (
                    <td key={selectedPlansForCompare[index]}>
                      <p
                        className="bold"
                        style={{
                          height:
                            planNames.length > 1 &&
                            (arr[index] !== "0000" ? "105px" : "160px"),
                        }}
                      >
                        {x}
                      </p>
                      {arr[index] !== "0000" && (
                        <button
                          className="btn btn-shp btn-shp-default"
                          id={arr[index]}
                          onClick={(e) => enrollHandler(e, arr[index])}
                        >
                          <Text id="sharp.Enroll" />
                        </button>
                      )}
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data &&
                  Object.keys(data).map((x) => {
                    return (
                      <>
                        <tr className="tr-subheading">
                          <td colSpan={5}>
                            {LANG.PLAN_DETAILS.HEADINGS[x] && language === "es"
                              ? LANG.PLAN_DETAILS.HEADINGS[x]
                              : x}
                          </td>
                        </tr>

                        {data[x].map((y, index) => {
                          let isObject = false;
                          isObject = Object.keys(y).some(
                            (z) => y[z] instanceof Object === true
                          );
                          if (isObject === true) {
                            let arr1 = [];
                            let subHeading = [];
                            Object.keys(y).forEach((w) => {
                              if (y[w] instanceof Object === true) {
                                arr1.push(y[w]);
                              } else {
                                subHeading.push(y[w]);
                              }
                            });
                            let key = Object.keys(arr1[0]);
                            key.sort();
                            let arrObj = [];
                            key.forEach((k) => {
                              let obj = { key: k };
                              arr1.forEach((a, index3) => {
                                let val = `val${index3}`;
                                Object.assign(obj, { [val]: a[k] });
                              });
                              arrObj.push(obj);
                            });
                            return (
                              <>
                                <tr>
                                  <td>
                                    <strong>
                                      {LANG.PLAN_DETAILS.SUB_HEADINGS[
                                        subHeading[0]
                                      ] && language === "es"
                                        ? LANG.PLAN_DETAILS.SUB_HEADINGS[
                                            subHeading[0]
                                          ]
                                        : subHeading[0]}
                                    </strong>
                                  </td>
                                  {planDetailTable.map((h, i) => (
                                    <td key={`i${77}`}></td>
                                  ))}
                                </tr>
                                {/* <tr> */}
                                {arrObj.map((q, index2) => (
                                  <tr key={`index2${14}`}>
                                    {Object.keys(q).map((z, index1) => (
                                      <td key={`index2${1}`}>
                                        {LANG.PLAN_DETAILS.DETAILS_KEYS[q[z]] &&
                                        language === "es"
                                          ? LANG.PLAN_DETAILS.DETAILS_KEYS[q[z]]
                                          : q[z]}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </>
                            );
                          } else {
                            return (
                              <tr key={`index${11}`}>
                                {Object.keys(y).map((z) => (
                                  <td key={`index${1}`}>
                                    {language === "es"
                                      ? findSpanish(y[z])
                                      : y[z]}
                                  </td>
                                ))}
                              </tr>
                            );
                          }
                        })}
                      </>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  );
};
export default PlanCompareGrid;
